export default {
    login: {
        title: 'Zhongshan Ophthalmology Center Artificial Intelligent Platform',
        titleImg: 'en',
        desc: 'Established in Zhongshan Ophthalmic Center, the department of artificial intelligence and big data is the first clinical department of artificial intelligence home and abroad. Based on the national top-tier hospital for clinical eye care and ophthalmic research, the department focused on research and development of ophthalmic diagnostic platform. We pioneered to formulate the application standard and operation guidelines for medical artificial intelligence, leading the innovative service mode of prevention and treatment for eye diseases in China.',
        form: {
            title: 'Platform Login',
            username: 'Username',
            password: 'Password',
            captcha: 'Verification code',
            login: 'Login',
            usernameRequired: 'Please enter username',
            passwordRequired: 'Please enter password',
            loginError: 'Failed to login',
            loginErrorNeedModifyPassword: 'Failed to login, please change password or contact help service from yiducloud',
            loginErrorUsernameOrPassword: 'Wrong username or password',
        },
    },
    gzzoc: {
        returnHome: 'Return',
        title: 'Zhongshan Ophthalmic Center <br/> Artificial Intelligent  Platform',
        numberPlease: 'Plase enter number',
        contentPlease: 'Plase enter content',
        contentPlease2: 'Plase enter content',
        quguangduResult: 'Diopter prediction result',
        normalRange: 'Normal range：',
        qingdu: 'Mild myopia：',
        gaodu: 'Sever myopia：',
        yuanshi: 'Hyperopia：',
        execFailed: 'Execution failed, please try again',
        sphericalEquivalent: 'Spherical Equivalent ',
        bcVisualAcuity: 'Best-corrected Visual Acuity',
        prPrevYear: 'PR during the Previous Year',
        report: '',
        diagnosticSuggest: 'All Suggestions',
        KIDS: "KIDS Results",
        analysis: 'Chief Complaints',
        predictedResults: 'Quality Analysis Results',
        diagnosticResult: 'Diagnosis',
        treatmentSuggest: 'Treatment',
        baineizhang: '白内障en',
        nurou: '胬肉en',
        jiemoxiachuxue: '结膜下出血en',
        jiaomoyan: '角膜炎en',
        doctorSignature: 'Doctor',
        date: 'Date',
        upload: 'Upload',
        downloadSample: 'Download Sample',
        downloadReport: 'Download Report',
        prepareDownload: 'Downloading',
        reportTitle: 'Artificial Intelligence Report\nZhongshan Ophthalmic Center, Sun Yat-sen University',
        FundusImageQualitReportTitle: 'AI-Based Fundus Image Quality Analysis Report\nZhongshan Ophthalmic Center, Sun Yat-sen University',
        fiveYearResult: 'Actual Spherical Equivalent at {year} Year Length',
        myopiaHighRisk: 'You will suffer the risk of high myopia.',
        myopiaLowRisk: 'You will not suffer the risk of high myopia.',
        myopiaTip: 'However，additional outdoor activity is an effective alternative to protect you from myopia progression.',
        anemiaPhotoTitle: 'Photo capture instruction',
        anemiaRisk1: 'Conjunctivae: Pull the lower eyelid downward to exposure the red inferior palpebral conjunctivae, and take a photo at a distance of about 0.5 m.',
        anemiaRisk2: 'Nails: Bend the fingers to exposure the fingernail beds, and take a photo at a distance of about 0.5 m.',
        leftEyeTitle: 'Left',
        rightEyeTitle: 'Right',
        eyelidTitle: 'Eyelid',
        nailTitle: 'Nail',
        eyeImgsTitle: 'EyeImgs',
        imgTip: 'One eye or two eyes are acceptable',
        imgTipData: 'One eye or two eyes are acceptable',
        modelError: 'Sorry, something went wrong, please try again.',
        name: 'Name',
        gender: 'Gender',
        age: 'Age',
        ageUnit: '',
        diagnosisTypeTitle: 'Type of Diagnosis',
        AIimageAnalysisResults:'AI image analysis results',
        Suggestion:'AI Diagnosis',
        Confidence:'Confidence',
        AIreferralAdvice:'AI referral advice',
        blackMoleTitle: 'Analysis report of the black tumor model on the ocular surface of Zhongshan Ophthalmology Center, Sun Yat-sen University',
        ocularEmergencyTriage:"Analysis report of triage model of Zhongshan Ophthalmology Center of Sun Yat-sen University",
        missFlag:'No tumor detected， please shoot again！',
        triageMessage: "Suggestion",
        triageGrade: "Grade",
        SemiEmergency:"Semi-Emergency",
        Emergency:"Emergency",
        nonEmergency:"Non-Emergency",
    },
    message: {
        name: 'Please enter patient\'s name',
        number: 'Please enter a number',
        maxAge: 'Please enter correct age',
        phone: "Please enter your phone number",
        right_phone: "Please enter the correct phone number",
        nameLimit: 'Cannot exceed 20 characters',
        ageLimit: 'No more than 3 digits',
        age: 'Please enter patient\'s age',
        img: 'Please upload an image',
        imgTypeUnknown: 'The image you upload is not recognizable, please choose another.',
        pdfTypeUnknown: 'The file format is wrong, please convert the file format to PDF or TIF file and upload it',
        imgSizeExceed: 'The image size should not exceed {size} MB',
        imgUploadSuccess: 'Image upload successful',
        imgUploadFail: 'Image upload failed',
        imgAtLeastOne: 'Upload at least one image',
        imgAtLeastAll: 'Upload at all image',
        checkInput: 'Please check input',
        diagnosisType: 'Please select the type of diagnosis',
        cameraBrand: 'Please enter camera brand',
        cameraModel: 'Please enter camera model',
        qualityType: 'Please select the quality analysis category',
    },
    gzzoc_triage: [
        {
          data_type: "string",
          default_value: null,
          display: "name",
          subValue: "姓名",
          key_type: "public",
          name: "name",
          options: null,
          order: 0,
          ques_type: "completion",
          show_type: null,
          value: "",
        },
        {
          data_type: "string",
          default_value: null,
          display: "age",
          subValue: "年龄",
          key_type: "public",
          name: "age",
          options: null,
          order: 0,
          ques_type: "completion",
          show_type: null,
          value: "",
        },
        {
          data_type: null,
          default_value: "1",
          display: "gender",
          subValue: "性别",
          key_type: "public",
          name: "gender",
          options: [
            { show_name: "man", value: "1" },
            { show_name: "female", value: "0" },
          ],
          order: 0,
          ques_type: "single_choice",
          show_type: "select",
          value: "1",
        },
        {
          data_type: "title",
          key_type: "event",
          name: "event",
          tip: "",
          title: "Event",
          value: "",
        },
        {
          data_type: null,
          default_value: "0",
          key_type: "public",
          display: "Event",
          subValue: "事件",
          name: "event",
          options: [
            {
              title: "Mechanical ocular traum",
              options: [
                {
                  value: "锐器性机械性眼外伤",
                  show_name:
                    "Sharp injury (e.g., rebound nails, scissors, toothpicks, finger jabs, etc)",
                },
                {
                  value: "钝器性机械性眼外伤",
                  show_name:
                    "Blunt injury (e.g., balls, fists, sticks, handlebar, all kinds of blunt objects, etc)",
                },
                {
                  value: "烟花爆竹",
                  show_name: "Explosive injury",
                },
              ],
            },
            {
              title: "Chemical burn",
              options: [
                {
                  value: "工业生产",
                  show_name: "Industrial production (such as glue, motor oil, bleaching powder, putty powder, etc.）",
                },
                {
                  value: "生活意外",
                  show_name: "Accidents in life (such as detergent, laundry detergent, shampoo and shower gel, chili oil, etc.)",
                },
              ],
            },
            {
              title: "Foreign body in the eye",
              options: [
                {
                  value: "异物入眼",
                  show_name: "Solid particles,(e.g., sand grain, dust, scrap iron, electric spark of cutting machine, etc)",
                },
              ],
            },
            {
              title: "Ultraviolet damage",
              options: [
                {
                  value: "射线性损伤",
                  show_name: "(e.g., UV lamp, electric welding, skiing, desert, etc)",
                },
              ],
            },
            {
              title: "Thermal burn",
              options: [
                {
                  value: "热灼伤",
                  show_name: "(e.g., Hot water, oil, soup, etc)",
                },
              ],
            },
            {
              title: "NO",
              options: [
                {
                  value: "0",
                  show_name: "NO",
                },
              ],
            },
          ],
          ques_type: "single_choice",
          show_type: "select",
          value: "0",
        },
        {
          data_type: "title",
          key_type: "symptoms",
          name: "symptoms",
          tip: "",
          title: "Symptoms",
          value: "",
        },
        {
          data_type: null,
          default_value: "od",
          display: "Symptoms",
          subValue: "症状",
          key_type: "symptoms",
          name: "symptoms",
          options: [
            {
              data_type: null,
              default_value: "od",
              display: "eye",
              subValue: "眼别",
              name: "eye",
              options: [
                { value: "od", show_name: "OD" },
                { value: "os", show_name: "OS" },
                { value: "ou", show_name: "OU" },
              ],
              order: 0,
              ques_type: "single_choice",
              show_type: "select",
              value: "od",
            },
            {
              data_type: null,
              default_value: "<7天",
              display: "Duration of complaint",
              subValue: "发病时间",
              name: "duration_complaint",
              options: [
                { value: "<7天", show_name: "<7 days" },
                { value: ">7天", show_name: ">7 days" },
              ],
              order: 0,
              ques_type: "single_choice",
              show_type: "select",
              value: "<7天",
            },
            {
              data_type: null,
              default_value: [],
              display: "Vision",
              subValue: "视力相关",
              name: "blurredVision",
              options: [
                { value: "视力下降", show_name: "Blurred vision" },
                {
                  value: "黑影遮挡",
                  show_name:
                    "Visual field defect",
                },
                { value: "闪光感", show_name: "Flashes" },
                {
                  value: "眼前漂浮物",
                  show_name: "Floats",
                },
              ],
              children: [
                {
                  data_type: null,
                  default_value: "几分钟内",
                  display: "a.How quickly",
                  subValue: "a.发生快慢",
                  name: "how_quickly",
                  options: [
                    { value: "几分钟内", show_name: "Within minutes" },
                    { value: "几小时内", show_name: "Within hours" },
                    { value: "几天内", show_name: "Within days" },
                    { value: "逐渐持续性", show_name: "＞7 days" },
                  ],
                  order: 0,
                  ques_type: "single_choice",
                  show_type: "select",
                  value: "几分钟内",
                },
                {
                  data_type: null,
                  default_value: "一过性",
                  display: "b. Duration",
                  subValue: "b.持续时间",
                  name: "duration",
                  options: [
                    { value: "一过性", show_name: "Persistent" },
                    { value: "持续性", show_name: "Transient" },
                  ],
                  order: 0,
                  ques_type: "single_choice",
                  show_type: "select",
                  value: "一过性",
                },
                {
                  data_type: null,
                  default_value: "显著",
                  display: "c.Degree",
                  subValue: "c.下降程度",
                  name: "degree",
                  options: [
                    { value: "显著", show_name: "significant" },
                    { value: "中度", show_name: "moderate" },
                    { value: "轻度", show_name: "mild " },
                  ],
                  order: 0,
                  ques_type: "single_choice",
                  show_type: "select",
                  value: "显著",
                },
              ],
              order: 0,
              ques_type: "multi_choice",
              show_type: "select",
              value: [],
            },
            {
              data_type: null,
              default_value: "",
              display: "Eye pain",
              subValue: "眼痛",
              name: "eye_pain",
              options: [
                { value: "<7天", show_name: "<7天" },
                { value: ">7天", show_name: ">7天" },
              ],
              children: [
                {
                  data_type: null,
                  default_value: "",
                  display: "Pain nature",
                  subValue: "性质",
                  name: "pain_nature",
                  options: [
                    { value: "刺痛", show_name: "Sharp pain" },
                    { value: "胀痛", show_name: " Dull pain" },
                  ],
                  order: 0,
                  ques_type: "single_choice",
                  show_type: "select",
                  value: "",
                },
                {
                  data_type: null,
                  default_value: "",
                  display: "Degree",
                  subValue: "程度",
                  name: "degree",
                  options: [
                    { value: "尚能忍受", show_name: "Tolerable " },
                    {
                      value: "不能忍受",
                      show_name: "Intolerable(Tearing and pain when blinking, resulting in reluctance to open eyes)",
                    },
                    {
                      value: "不能忍受，伴同侧头痛、恶心呕吐",
                      show_name: "Intolerable, accompanied by ipsilateral headache, nausea or vomiting",
                    },
                  ],
                  order: 0,
                  ques_type: "single_choice",
                  show_type: "select",
                  value: "",
                },
              ],
              order: 0,
              ques_type: "title_choice",
              show_type: "select",
              value: "",
            },
            {
              data_type: null,
              default_value: [],
              display: "Others",
              subValue: "其他",
              name: "others",
              options: [
                { value: "畏光", show_name: "Photophobia" },
                { value: "流泪", show_name: "Tearing" },
              ],
              order: 0,
              ques_type: "multi_choice",
              show_type: "select",
              value: [],
            },
            {
              data_type: null,
              default_value: "0",
              display: "excessively swollen eyelid",
              subValue: "眼肿睁不开",
              name: "eye_swelling",
              options: [{ value: "1", show_name: "Yes" },{ value: "0", show_name: "No" }],
              order: 0,
              ques_type: "single_choice",
              show_type: "select",
              value: "0",
            },
          ],
          order: 0,
          ques_type: "single_choice",
          show_type: "select",
          value: "",
        },
        {
          data_type: "title",
          key_type: "medical_history",
          name: "medical_history",
          tip: "",
          title: "Medical history",
          value: "",
        },
        {
          data_type: null,
          default_value: "无",
          display: "General disease",
          subValue: "全身疾病史",
          key_type: "medical_history",
          name: "general_disease",
          options: [
            { value: "无", show_name: "NO" },
            {
              value: "风湿疾病史",
              show_name: "Rheumatoid diseases (e.g., rheumatoid, arthritis, compulsive spondylitis, etc)",
            },
          ],
          order: 0,
          ques_type: "single_choice",
          show_type: "select",
          value: "无",
        },
        {
          data_type: null,
          default_value: [0],
          display: "Ocular diseases",
          subValue: "眼科疾病史",
          key_type: "medical_history",
          name: "ocular_diseases",
          options: [
            { value: 0, show_name: "No" },
            { value: "白内障", show_name: "Cataract" },
            { value: "青光眼", show_name: "Glaucoma" },
            { value: "佩戴角膜接触镜", show_name: "Wear contact lenses" },
            { value: "眼底病", show_name: "Fundus disease" },
            { value: "角膜炎", show_name: "Keratitis" },
            { value: "葡萄膜炎", show_name: "Uveitis" },
            { value: "眼外伤史", show_name: "cular trauma" },
            { value: "高度近视", show_name: "High myopia" },
          ],
          order: 0,
          ques_type: "multi_choice",
          show_type: "select",
          value: [0],
        },
        {
          data_type: null,
          default_value: "0",
          display: "History of eye surgeries",
          subValue: "眼科手术史",
          key_type: "medical_history",
          name: "eye_surgeries",
          options: [
            { value: "0", show_name: "No" },
            { value: "1", show_name: "YES" },
          ],
          select: [
            {
              title: "within a month",
              type:'within',
              value: [],
              options: [
                {
                  value: "cataract surgery",
                  label: "cataract surgery",
                  select: "",
                },
                {
                  value: "corneal transplantation surgery",
                  label: "corneal transplantation surgery",
                  select: "",
                },
                {
                  value: "corneal foreign body removal surgery",
                  label: "corneal foreign body removal surgery",
                  select: "",
                },
                {
                  value: "pterygium excision surgery",
                  label: "pterygium excision surgery",
                  select: "",
                },
                {
                  value: "glaucoma surgery",
                  label: "glaucoma surgery",
                  select: "",
                },
                {
                  value: "retinal hole photocoagulation",
                  label: "retinal hole photocoagulation",
                  select: "",
                },
                {
                  value: "retinal surgery",
                  label: "retinal surgery",
                  select: "",
                },
                {
                  value: "eyelid surgery",
                  label: "eyelid surgery",
                  select: "",
                },
                {
                  value: "corneal laceration suture surgery",
                  label: "corneal laceration suture surgery",
                  select: "",
                }
              ],
            },
            {
              title: "a month ago",
              type:'ago',
              value: [],
              options: [
                {
                  value: "cataract surgery",
                  label: "cataract surgery",
                  select: "",
                },
                {
                  value: "corneal transplantation surgery",
                  label: "corneal transplantation surgery",
                  select: "",
                },
                {
                  value: "corneal foreign body removal surgery",
                  label: "corneal foreign body removal surgery",
                  select: "",
                },
                {
                  value: "pterygium excision surgery",
                  label: "pterygium excision surgery",
                  select: "",
                },
                {
                  value: "glaucoma surgery",
                  label: "glaucoma surgery",
                  select: "",
                },
                {
                  value: "retinal hole photocoagulation",
                  label: "retinal hole photocoagulation",
                  select: "",
                },
                {
                  value: "retinal surgery",
                  label: "retinal surgery",
                  select: "",
                },
                {
                  value: "eyelid surgery",
                  label: "eyelid surgery",
                  select: "",
                },
                {
                  value: "corneal laceration suture surgery",
                  label: "corneal laceration suture surgery",
                  select: "",
                }
              ],
            },
          ],
          order: 0,
          ques_type: "single_choice",
          show_type: "select",
          value: "0",
        },
        {
          data_type: null,
          default_value: null,
          display: "image",
          subValue: "图像",
          key_type: "eye_imgs",
          name: "eyelid_images",
          options: null,
          order: 0,
          ques_type: "file",
          show_type: null,
          value: "",
        },
      ],
    coming: 'Coming soon',
    logout: 'Logout',
    startPredict: 'Start',
    startAnalysis: 'Go',
    reset: 'Reset',
    save: "Save",
    expand: 'Expand',
    collapse: 'Collapse',
    welcomeUse: 'Welcome',
    noResult: 'No result',
    pleaseRepredict: 'Predict again',
    projectDesc: 'Introduction',
    reference: 'Reference',
    pleaseCheckInput: 'Please check input',
    noPermission: 'You have no access to this platform',
    algorithm: 'Algorithm',
    requestFailed: 'request failed',
    visionomeIntroduction: 'Introduction of the Visionome',
    ccIntroduction: 'Introduction of CC-Cruiser',
    glaucomaroduction: 'Introduction of Glaucoma',
    EyeSelect:'Please select the corresponding surgery',
    clinicalData:"Clinical Data",
    fundusPhotography:"Fundus Photography",
    fundusPhotographyTip:"Please upload images of both eyes",
    notEntered:"Not entered",
    requiredField:"required field",
    return:"Return",
    reEnter:"Next",
    noData:"No data available",
    pathologicalClassification:"Pathological classification(probability)",
    glomerulosclerosisRatio:"The Probability of PSG ≥ 75%",
    prognosticPredictionResults:"Prognosis prediction",
    prognosticPredictionResults2:"The Probability of Outcome Events within 5 Years",
    applicationFeedback:"application feedback",
    yourPosition:"Your title",
    feedpackFormItem1:"Consistent with your judgement",
    feedpackFormItem2:"Availability of pathological results",
    feedpackFormItem3:"Consistent with pathological results",
    feedpackFormItem4:"Adjustment of current treatment",
    feedpackFormItem5:"Whether to adjust the patient's follow-up plan based on prognostic predictions",
    feedpackFormItem6:"Pathological diagnosis results of renal biopsy",
    feedpackFormItem7:"Your presumed primary diagnosis",
    junior:"junior",
    intermediate:"intermediate",
    senior:"senior",
    sumbit: "sumbit",
    yes: "yes", 
    no: "no",
    yes2: "yes", 
    confirm: 'confirm',
    cancel: 'cancel',
    text1: 'The input value is out of range, please enter',
    text2: 'Please submit application feedback',
    text3: 'The value exceeds the range and does not comply with the specifications',
    text4: 'prompt',
    text5: 'Whether to automatically load the latest temporary storage information',
    text6: 'Save successful',
    text7: 'Reset Success',
    no2: "no",
    CKDDes: "The diagnostic results are references for doctors",
    IgAN: "IgAN",
    DN: "DN",
    ANS: "ANS",
    MN: "MN",
    MCD: "MCD/FSGS",
    ckd2Title: "ZOC AI Diagnostic Report for Chronic Kidney Disease",
    heightTip: "The height is in meters. Please enter the number 0-2",
    feedbackTip: "Submit feedback successfully",
  };
